import classnames from 'classnames';

import {CloseButton} from './close-button';

import styles from './ai-feature-gate-modal.module.css';

interface Props {
    children: React.ReactNode;
    onClose: () => void;
    footerAction?: React.ReactNode;
    centerContent?: boolean;
}

export function GateContentLayout(props: Props) {
    const contentClassName = classnames(styles['right-pane-content'], {
        'flex flex-dir-col justify-center': props.centerContent,
    });

    const footerClassName = classnames(styles.footer, {
        'justify-end': !props.footerAction,
    });

    return (
        <div className='flex flex-dir-col full-height border-box'>
            <div className={contentClassName}>{props.children}</div>
            <div className={footerClassName}>
                <CloseButton onClick={props.onClose} />
                {props.footerAction}
            </div>
        </div>
    );
}
